import React, { useEffect, useState } from 'react';
import { FullscreenModal } from '../../../common/fullscreenModal/FullscreenModal';
import {
  Badge,
  ButtonPrimary,
  Loader,
  ModalContent,
  ModalHeader,
} from '@skf/bt-wind-rail-commonlibrary';
import { useTranslation } from 'react-i18next';
import { ExtendedUser } from '../../../../store/users/types';
import style from './UserManagementDelete.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { clearUsersError, deleteUser } from '../../../../store/users/actions';
import { IUsersState } from '../../../../store/users/store';
import { StoreState } from '../../../../store/store';
import { isValidResponse } from '../../../../services/responseService';
import { useToast } from '../../../../hooks/useToast';

interface IUserManagementDeleteProps {
  user?: ExtendedUser;
  onClose: () => void;
}

export const UserManagementDelete: React.FunctionComponent<IUserManagementDeleteProps> = ({
  user,
  onClose,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { addToast } = useToast();

  const [isFetching, setFetching] = useState<boolean>(false);

  const { message, status }: IUsersState = useSelector<StoreState, IUsersState>(
    (state) => state.users
  );

  const onClickClose = () => !isFetching && onClose();

  useEffect(() => {
    const _isValidResponse = isValidResponse(status);
    if (isFetching && _isValidResponse) {
      addToast({
        status: 'ok',
        message: t('User_successfully_deleted'),
      });
      dispatch(clearUsersError());
      return onClose();
    }

    if (!status || !message) return;
    addToast({
      status: 'danger',
      message: message || `Error ${status}`,
    });
    dispatch(clearUsersError());
    setFetching(false);
  }, [message, status]);

  const onClickSubmit = () => {
    dispatch(
      deleteUser(user?.userName.toLowerCase(), user?.userEmail.toLowerCase())
    );
    setFetching(true);
  };

  return (
    <FullscreenModal onClose={onClickClose} className={style.modal}>
      <ModalHeader onClose={onClickClose}>{t('Delete_User')}</ModalHeader>
      <ModalContent className={style.content}>
        <>
          <Loader center show={isFetching} className={style.loader} />
          <div className={isFetching ? style.blur : ''}>
            <div className={style.container}>
              {t('You_are_trying_to_delete')}
              <Badge className={style.badge}>{user?.userName}</Badge>,{' '}
              {t('are_you_sure')}?
            </div>
            <div className={style.navigation}>
              <ButtonPrimary onClick={onClickClose} outline>
                {t('Cancel')}
              </ButtonPrimary>
              <ButtonPrimary onClick={onClickSubmit}>{t('Ok')}</ButtonPrimary>
            </div>
          </div>
        </>
      </ModalContent>
    </FullscreenModal>
  );
};
